import { loadStripe } from '@stripe/stripe-js';

// Load the Stripe publishable key from environment variables
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_live_51TASBa2L6siz0VxCMOZJu2gDKOSebFUtVhIcnLIi4JKVBz0UHp2SMOfiXbO738XsHeqgzKirOdPoMGOoXT5qCgzE00rp9UTIHv';

// Initialize Stripe
export let stripePromise = loadStripe(stripePublishableKey);

export const getStripe = () => {
  return stripePromise;
};

// Validate Stripe publishable key
if (!stripePublishableKey) {
  console.warn('Missing Stripe publishable key. Payment features will not work properly.');
}
